import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import AboutPage from '../pages/AboutPage';
import ServicesPage from '../pages/ServicesPage';
import ServicesPageV2 from '../pages/ServicesPageV2';
import BookingPage from '../pages/BookingPage';
import FranchiseSelectionPage from '../pages/FranchiseSelectionPage';

/**
 * AppRoutes
 * Defines all application routes
 */
export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services-v2" element={<ServicesPageV2 />} />
      <Route path="/booking" element={<BookingPage />} />
      <Route path="/franchise-selection" element={<FranchiseSelectionPage />} />
    </Routes>
  );
};
